export enum ContactHostOrigin {
  EVENT_LANDING = "event-landing",
  MIC_CAM_CHECK = "mic-cam-check",
}
